import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

import Container from "./container"

import colors from "../settings/colors"

import sbcsLogo from "../images/sbcsblack.png"
import muLogo from "../images/mu.gif"
import camLogo from "../images/cam.png"

const Footer = styled.footer`
    background-color: white;
    position: relative;
    z-index: 1;
    margin-top: 50px;
    top: -50px;

    > div:nth-child(1) {
        display: flex;
        flex-flow: ${isMobile ? "column":"unset"};

        align-items: center;
        justify-content: space-between;

        > div {
            display: flex;
            align-items: center;            
        }
    }
    &:before {
        background: inherit;
        top: 0;
        content: '';
        display: block;
        height: 50%;
        left: 0;
        position: absolute;
        right: 0;
        transform: skewY(2.5deg);
        transform-origin: 100%;
        z-index: -1;
    }

    a {
        text-decoration: none;
    }
`
const Copyright = styled.div`
    color: #666;
    padding: 0px 25px 10px 25px;
    font-size: 85%;
    text-align: ${isMobile ? "center":"left"};
`

function SiteFooter(props) {

  return (
    <Footer>
        <Container>
            <div>
                <a href="http://www.marshall.edu/" target="_blank">
                    <img src={muLogo} alt="Marshall University" width="135" />
                </a>
                <a href="http://www.marshall.edu/cofa/" target="_blank">
                    <img src={camLogo} alt="Marshall College Of Arts & Media" width="100" />
                </a>
            </div>
            <div>
                <a href="https://www.sbcs.com/" target="_blank">
                    <img src={sbcsLogo} alt="Strictly Business Computer Systems" width="150" />
                </a>
            </div>
        </Container> 
        <Container nopadding={true}> 
            <Copyright>© 2001-2024 Marshall Artists Series</Copyright>
        </Container> 
    </Footer>
  );
}

export default SiteFooter;